import { Button, Stack } from "@mui/material";
import { useCancellationContinue } from "src/hooks/useCancellationContinue";

interface Props {
  continueText: string;
  refuseText: string;
  onRefuse: () => void;
  question: string;
}

const CancellationFooter = ({
  continueText,
  refuseText,
  onRefuse,
  question,
}: Props) => {
  const next = useCancellationContinue();

  return (
    <Stack direction="row" gap={2}>
      <Button fullWidth variant="outlined" onClick={onRefuse}>
        {refuseText}
      </Button>
      <Button fullWidth onClick={() => next(question)}>
        {continueText}
      </Button>
    </Stack>
  );
};

export default CancellationFooter;
